module.exports = __webpack_public_path__ + "static/media/bowen-52.dcdde88b.jpg";